import React from "react";
import BorderBlock from "./components/BorderBlock";
import "./styles.scss";
import GeneratorPrivateHash from "./components/GeneratorPrivateHash";
import LegalEntity from "./components/LegalEntity";
import CountryCode from "./components/CountryCode";
import FeedBackBlock from "./components/FeedBackBlock";
import { useCountryCode } from "./hooks/useCountryCode";
import LinkOfferCreate from "./components/LinkOfferCreate";

function App() {
  const {
    countryData,
    value,
    handleChangeSelect,
    sortCountryDataArray,
    search,
    setSearch,
    filterCountryData,
    handleChangeSelectBeforeSearch,
    aftereffect,
    arabCountry,
  } = useCountryCode();

  return (
    <div className="App">
      <BorderBlock>
        <GeneratorPrivateHash />
      </BorderBlock>
      <BorderBlock>
        <LegalEntity />
      </BorderBlock>
      <BorderBlock>
        <FeedBackBlock value={value} />
      </BorderBlock>
      <BorderBlock>
        <CountryCode
          data={{
            countryData,
            value,
            handleChangeSelect,
            sortCountryDataArray,
            search,
            setSearch,
            filterCountryData,
            handleChangeSelectBeforeSearch,
            aftereffect,
            arabCountry,
          }}
        />
      </BorderBlock>
      <BorderBlock>
        <LinkOfferCreate />
      </BorderBlock>
    </div>
  );
}

export default App;
